/* eslint-disable no-use-before-define */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { assign, isNil, isEqual, isEmpty } from 'lodash';
import { Table, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { getBsProps } from 'react-bootstrap/lib/utils/bootstrapUtils';
import { isIAS, isMaps } from '../../../modules/checkDeployEnv';

import TableButtonCell from '../../atoms/TableButtonCell';

const TableHeader = ({ deployEnv }) => (
  <thead>
    <tr>
      <th>Name</th>
      {isIAS(deployEnv) && (
        <>
          <th>URL</th>
          <th className="text-center" />
        </>
      )}
      {isMaps(deployEnv) && (
        <>
          <th>Server Type</th>
          <th>IP</th>
          <th>Port</th>
        </>
      )}
      <th className="text-center" />
      <th className="text-center" />
    </tr>
  </thead>
);
TableHeader.propTypes = {
  deployEnv: PropTypes.string.isRequired
};

/**
 * Takes in an array of objects from data base and return a
 * table a row for each item with the requested cells to display.
 *
 * @param {object[]} itemList - An array with the objects from the database.
 */
const TableBody = ({ itemList, addNew, ...props }) => {
  const TableRows = itemList.map(telCon => {
    let classToAdd = '';
    if (telCon.selected) {
      classToAdd += 'table-info';
    }
    return (
      <tr className={classToAdd} key={telCon._id}>
        <ItemCells telCon={telCon} {...props} />
      </tr>
    );
  });
  if (addNew) {
    return (
      <tbody>
        {TableRows}
        <tr>
          <AddNewCells {...props} />
        </tr>
      </tbody>
    );
  }
  return <tbody>{TableRows}</tbody>;
};
TableBody.propTypes = {
  itemList: PropTypes.array.isRequired,
  addNew: PropTypes.bool.isRequired
};

const DeleteButton = ({ telConId, deleteFunction }) => (
  <TableButtonCell>
    <Button variant="danger" onClick={() => deleteFunction(telConId)}>
      <FontAwesomeIcon icon="times" size="lg" />
    </Button>
  </TableButtonCell>
);

DeleteButton.propTypes = {
  telConId: PropTypes.string.isRequired,
  deleteFunction: PropTypes.func.isRequired
};

const RadioButton = ({ telConId, isSelected, toggleCheck }) => (
  <TableButtonCell>
    <Button
      variant={isSelected ? 'success' : 'light'}
      onClick={() => toggleCheck(telConId, isSelected)}
    >
      {isSelected ? (
        <FontAwesomeIcon icon={['far', 'check-circle']} size="lg" />
      ) : (
        <FontAwesomeIcon icon={['far', 'circle']} size="lg" />
      )}
    </Button>
  </TableButtonCell>
);

RadioButton.propTypes = {
  telConId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  toggleCheck: PropTypes.func.isRequired
};

const EditButton = ({ telConId, toggleEditor }) => (
  <TableButtonCell>
    <Button
      variant="light"
      onClick={() => {
        toggleEditor(telConId, true);
      }}
    >
      <FontAwesomeIcon icon="edit" size="lg" />
    </Button>
  </TableButtonCell>
);

EditButton.propTypes = {
  telConId: PropTypes.string.isRequired,
  toggleEditor: PropTypes.func.isRequired
};

const CleanIP = newTelCon => {
  if (newTelCon.serverType === 'GMS' && isEmpty(newTelCon.ip)) {
    const updateNewTelConn = newTelCon;
    const { domain } = newTelCon;

    const newDomain = domain.split('://');
    if (newDomain.length <= 1) {
      const newValue = newDomain[0];
      updateNewTelConn.domain = newValue;
    } else {
      const newValue = newDomain[1];
      updateNewTelConn.domain = newValue;
    }

    return updateNewTelConn;
  }
  return newTelCon;
};

const SaveButton = ({ telConId, saveTelCon, newTelCon, toggleEditor }) => (
  <TableButtonCell>
    <Button
      onClick={() => {
        const updateNewTelConn = CleanIP(newTelCon);
        saveTelCon(updateNewTelConn);
        toggleEditor(telConId, false);
      }}
    >
      <FontAwesomeIcon icon="save" size="lg" />
    </Button>
  </TableButtonCell>
);

SaveButton.propTypes = {
  telConId: PropTypes.string.isRequired,
  saveTelCon: PropTypes.func.isRequired,
  toggleEditor: PropTypes.func.isRequired,
  newTelCon: PropTypes.object.isRequired
};

const ItemCells = props => {
  const {
    telCon,
    deployEnv,
    itemListState,
    editableTelCon,
    changeName,
    changeURL,
    changeDomain,
    changeIP,
    changePort,
    changeServerType,
    toggleEditor,
    updateTelConn,
    toggleSelected,
    removeTelConn
  } = props;
  const [serverTypeStatus, SetServerTypeStatus] = React.useState(telCon.serverType);

  const handleServerType = _serverType => {
    changeServerType(_serverType);
    if (_serverType === 'GMSS') {
      SetServerTypeStatus('GMS');
    } else {
      SetServerTypeStatus(_serverType);
    }
  };

  const checkServerType = serverType => {
    if (serverType === 'GMS') {
      if (isEmpty(telCon.ip)) {
        return 'GMSS';
      }
      return serverType;
    }
    return serverType;
  };
  const [isSecure, setIsSecure] = React.useState(checkServerType(telCon.serverType) === 'GMSS');

  if (!itemListState[telCon._id]) {
    return (
      <>
        <td className="align-middle">{telCon.name}</td>
        {isIAS(deployEnv) && (
          <>
            <td className="align-middle">{telCon.url}</td>
            <RadioButton
              telConId={telCon._id}
              isSelected={telCon.selected}
              toggleCheck={toggleSelected}
            />
          </>
        )}
        {isMaps(deployEnv) && (
          <>
            <td className="align-middle">{checkServerType(telCon.serverType)}</td>
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `GMS` && isEmpty(telCon.ip) && (
          <>
            <td className="align-middle">{`https://${telCon.domain}`}</td>
            <td className="align-middle" />
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `GMS` && !isEmpty(telCon.ip) && (
          <>
            <td className="align-middle">{telCon.ip}</td>
            <td className="align-middle">{telCon.port}</td>
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `DTS` && (
          <>
            <td className="align-middle">{telCon.domain}</td>
            <td className="align-middle" />
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `DFS` && (
          <>
            <td className="align-middle">{telCon.domain}</td>
            <td className="align-middle" />
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `IGP` && (
          <>
            <td className="align-middle">{telCon.ip}</td>
            <td className="align-middle">{telCon.port}</td>
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `IGPS` && (
          <>
            <td className="align-middle">{telCon.domain}</td>
            <td className="align-middle" />
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `CAT` && (
          <>
            <td className="align-middle">{telCon.ip}</td>
            <td className="align-middle">{telCon.port}</td>
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `CATS` && (
          <>
            <td className="align-middle">{telCon.domain}</td>
            <td className="align-middle" />
          </>
        )}
        {isMaps(deployEnv) && serverTypeStatus === `OGC-API-Features` && (
          <>
            <td className="align-middle">{telCon.domain}</td>
            <td className="align-middle" />
          </>
        )}
        <EditButton telConId={telCon._id} toggleEditor={toggleEditor} />
        <DeleteButton telConId={telCon._id} deleteFunction={removeTelConn} />
      </>
    );
  }
  return (
    <>
      <td className="align-middle">
        <Form.Control
          name="name"
          defaultValue={editableTelCon.name}
          onBlur={event => changeName(event.target.value.trim())}
        />
      </td>
      {isIAS(deployEnv) && (
        <>
          <td className="align-middle">
            <Form.Control
              name="url"
              defaultValue={editableTelCon.url}
              onBlur={event => changeURL(event.target.value.trim())}
            />
          </td>
          <td className="align-middle" />
        </>
      )}
      {isMaps(deployEnv) && (
        <>
          <td className="align-middle">
            <select
              className="form-select"
              aria-label="Select Server Type"
              defaultValue={checkServerType(editableTelCon.serverType)}
              onChange={event => {
                const value = event.target.value.trim();
                if (value === 'GMSS') {
                  setIsSecure(true);
                  handleServerType('GMSS');
                } else {
                  setIsSecure(false);
                  handleServerType(value);
                }
              }}
            >
              <option value=""> Select an option </option>
              <option value="GMS">Geo Micro Service</option>
              <option value="GMSS">Geo Micro Service Secure</option>
              <option value="DTS">Database Tile Server</option>
              <option value="DFS">Database Feature Server</option>
              <option value="IGP">Ipsilum Geoprocesing</option>
              <option value="IGPS">Ipsilum Geoprocesing Secure</option>
              <option value="CAT">Catalog</option>
              <option value="CATS">Catalog Secure</option>
            </select>
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `GMS` && !isSecure && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `GMS` && isSecure && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={`https://${editableTelCon.domain}`}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `DTS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `DFS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `IGP` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `IGPS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `CAT` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `CATS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `OGC-API-Features` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      <SaveButton
        saveTelCon={updateTelConn}
        telConId={telCon._id}
        toggleEditor={toggleEditor}
        newTelCon={editableTelCon}
      />
      <DeleteButton telConId={telCon._id} deleteFunction={removeTelConn} />
    </>
  );
};

ItemCells.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  telCon: PropTypes.object.isRequired,
  itemListState: PropTypes.object.isRequired,
  editableTelCon: PropTypes.object.isRequired,
  changeName: PropTypes.func.isRequired,
  changeURL: PropTypes.func.isRequired,
  changeDomain: PropTypes.func.isRequired,
  changeIP: PropTypes.func.isRequired,
  changePort: PropTypes.func.isRequired,
  changeServerType: PropTypes.func.isRequired,
  toggleEditor: PropTypes.func.isRequired,
  updateTelConn: PropTypes.func.isRequired,
  toggleSelected: PropTypes.func.isRequired,
  removeTelConn: PropTypes.func.isRequired
};

const AddNewCells = props => {
  const {
    deployEnv,
    editableTelCon,
    changeName,
    changeURL,
    changeDomain,
    changeIP,
    changePort,
    changeServerType,
    addTelConn,
    toggleAddNew
  } = props;

  const [serverTypeStatus, SetServerTypeStatus] = React.useState(editableTelCon.serverType);
  const [isSecure, setIsSecure] = React.useState(false);
  const handleServerType = _serverType => {
    changeServerType(_serverType);
    SetServerTypeStatus(_serverType);
  };

  return (
    <>
      <td>
        <Form.Control
          name="name"
          defaultValue={editableTelCon.name}
          onBlur={event => changeName(event.target.value.trim())}
        />
      </td>
      {isIAS(deployEnv) && (
        <>
          <td>
            <Form.Control
              name="url"
              defaultValue={editableTelCon.url}
              onBlur={event => changeURL(event.target.value.trim())}
            />
          </td>
          <td />
        </>
      )}
      {isMaps(deployEnv) && (
        <>
          <td className="align-middle">
            <select
              className="form-select"
              aria-label="Select Server Type"
              defaultValue={editableTelCon.serverType}
              onChange={event => {
                const value = event.target.value.trim();
                if (value === 'GMSS') {
                  setIsSecure(true);
                  handleServerType('GMS');
                } else {
                  setIsSecure(false);
                  handleServerType(value);
                }
              }}
            >
              <option value=""> Select an option </option>
              <option value="GMS">Geo Micro Service</option>
              <option value="GMSS">Geo Micro Service Secure</option>
              <option value="DTS">Database Tile Server</option>
              <option value="DFS">Database Feature Server</option>
              <option value="IGP">Ipsilum Geoprocesing</option>
              <option value="IGPS">Ipsilum Geoprocesing Secure</option>
              <option value="CAT">Catalog</option>
              <option value="CATS">Catalog Secure</option>
              <option value="OGC-API-Features">OGC API Features</option>
            </select>
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `GMS` && !isSecure && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `GMS` && isSecure && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `DTS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `DFS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `IGP` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `IGPS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `CAT` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="ip"
              defaultValue={editableTelCon.ip}
              onBlur={event => changeIP(event.target.value.trim())}
            />
          </td>
          <td className="align-middle">
            <Form.Control
              name="port"
              type="number"
              defaultValue={editableTelCon.port}
              onBlur={event => changePort(Number(event.target.value.trim()))}
            />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `CATS` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      {isMaps(deployEnv) && serverTypeStatus === `OGC-API-Features` && (
        <>
          <td className="align-middle">
            <Form.Control
              name="domain"
              defaultValue={editableTelCon.domain}
              onBlur={event => changeDomain(event.target.value.trim())}
            />
          </td>
          <td className="align-middle invisible">
            <Form.Control name="none" />
          </td>
        </>
      )}
      <TableButtonCell>
        <Button
          variant="light"
          onClick={() => {
            addTelConn(editableTelCon);
            toggleAddNew();
          }}
        >
          <FontAwesomeIcon icon="save" size="lg" />
        </Button>
      </TableButtonCell>
      <TableButtonCell>
        <Button variant="secondary" onClick={() => toggleAddNew()}>
          <FontAwesomeIcon icon="times" size="lg" />
        </Button>
      </TableButtonCell>
    </>
  );
};

AddNewCells.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  editableTelCon: PropTypes.object.isRequired,
  changeName: PropTypes.func.isRequired,
  changeURL: PropTypes.func.isRequired,
  changeDomain: PropTypes.func.isRequired,
  changeIP: PropTypes.func.isRequired,
  changePort: PropTypes.func.isRequired,
  changeServerType: PropTypes.func.isRequired,
  addTelConn: PropTypes.func.isRequired,
  toggleAddNew: PropTypes.func.isRequired
};

class TelemetryConnEditableTable extends Component {
  state = {
    editableTelCon: {
      name: '',
      url: '',
      domain: '',
      ip: '',
      port: 0
    },
    addNew: false
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    // Store prevUserId in state so we can compare when props change.
    // Clear out any previously-loaded user data (so we don't render stale stuff).
    let prevItemList = [];
    const nextItemList = [];
    if (!isNil(prevState.itemListState)) {
      prevItemList = Object.keys(prevState.itemListState);
      prevItemList.sort();
    }
    if (!isNil(nextProps.itemList)) {
      nextProps.itemList.forEach(item => {
        nextItemList.push(item._id);
      });
      nextItemList.sort();
    }
    const areItemsEqual = isEqual(prevItemList, nextItemList);
    if (areItemsEqual && !prevState.addNew) {
      // No state update necessary
      return null;
    }
    const itemListState = {};
    nextProps.itemList.forEach(item => {
      itemListState[item._id] = false;
    });
    return { itemListState };
  }

  toggleEditor = (itemId, editOn) => {
    const { itemListState: itemListStateOld } = this.state;
    const { itemList, deployEnv } = this.props;
    const itemListStateCopy = Object.assign({}, itemListStateOld);
    const allItemsIds = Object.keys(itemListStateCopy);
    allItemsIds.forEach(item => {
      itemListStateCopy[item] = false;
    });
    itemListStateCopy[itemId] = editOn;
    this.setState({ itemListState: itemListStateCopy });
    if (editOn) {
      const telToEdit = itemList.find(element => element._id === itemId);
      const editableTelCon = { name: telToEdit.name, _id: telToEdit._id };
      if (isIAS(deployEnv)) assign(editableTelCon, { url: telToEdit.url });
      if (isMaps(deployEnv))
        assign(editableTelCon, {
          ip: telToEdit.ip,
          serverType: telToEdit.serverType,
          port: telToEdit.port,
          domain: telToEdit.domain
        });
      this.setState({ editableTelCon });
    }
  };

  changeName = newName => {
    this.setState(prevState => ({
      editableTelCon: {
        ...prevState.editableTelCon,
        name: newName
      }
    }));
  };

  changeURL = newURL => {
    this.setState(prevState => ({
      editableTelCon: {
        ...prevState.editableTelCon,
        url: newURL
      }
    }));
  };

  changeDomain = newDomain => {
    this.setState(prevState => ({
      editableTelCon: {
        ...prevState.editableTelCon,
        domain: newDomain
      }
    }));
  };

  changeIP = newIp => {
    this.setState(prevState => ({
      editableTelCon: {
        ...prevState.editableTelCon,
        ip: newIp
      }
    }));
  };

  changePort = newPort => {
    this.setState(prevState => ({
      editableTelCon: {
        ...prevState.editableTelCon,
        port: newPort
      }
    }));
  };

  changeServerType = newServerType => {
    if (newServerType === 'GMS') {
      this.setState(prevState => ({
        editableTelCon: {
          ...prevState.editableTelCon,
          serverType: newServerType,
          domain: ''
        }
      }));
    } else if (newServerType === 'GMSS') {
      this.setState(prevState => {
        const newState = prevState.editableTelCon;
        delete newState.ip;
        return {
          editableTelCon: {
            ...newState,
            serverType: 'GMS',
            port: 0
          }
        };
      });
    } else {
      this.setState(prevState => ({
        editableTelCon: {
          ...prevState.editableTelCon,
          serverType: newServerType
        }
      }));
    }
  };

  toggleAddNew = () => {
    this.setState(prevState => ({
      editableTelCon: {
        name: '',
        url: '',
        domain: '',
        ip: '',
        port: 0
      },
      addNew: !prevState.addNew
    }));
  };

  render() {
    const { backButton } = this.props;
    return (
      <>
        <Table responsive size="sm">
          <TableHeader {...this.props} />
          <TableBody
            changeIP={this.changeIP}
            changeName={this.changeName}
            changePort={this.changePort}
            changeServerType={this.changeServerType}
            changeURL={this.changeURL}
            changeDomain={this.changeDomain}
            toggleAddNew={this.toggleAddNew}
            toggleEditor={this.toggleEditor}
            {...this.props}
            {...this.state}
          />
        </Table>
        <Button className="float-right" variant="outline-success" onClick={this.toggleAddNew}>
          Add New
        </Button>
        <Button className="float-right" variant="outline-secondary" onClick={backButton}>
          Back
        </Button>
      </>
    );
  }
}
TelemetryConnEditableTable.defaultProps = {
  backButton: () => {}
};
TelemetryConnEditableTable.propTypes = {
  deployEnv: PropTypes.string.isRequired,
  itemList: PropTypes.array.isRequired,
  addTelConn: PropTypes.func.isRequired,
  updateTelConn: PropTypes.func.isRequired,
  toggleSelected: PropTypes.func.isRequired,
  removeTelConn: PropTypes.func.isRequired,
  backButton: PropTypes.func
};

export default TelemetryConnEditableTable;
